import React from 'react';

type AdminFieldProps = {
  label: string;
  value: string;
  type: 'text' | 'number' | 'select';
  options?: string[];
  disabled?: boolean;
  onChange: (v: string) => void;
};

export const AdminField: React.FC<AdminFieldProps> = ({ label, value, type, options, disabled = false, onChange }) => (
  <div className="space-y-2">
    <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] ml-2">{label}</label>
    {type === 'select' ? (
      <div className="relative">
        <select value={value} onChange={e => onChange(e.target.value)} disabled={disabled} className={`w-full bg-slate-50 border-none rounded-2xl p-4 font-bold text-slate-800 focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}>
          {options?.map(o => <option key={o} value={o}>{o.replace('_', ' ')}</option>)}
        </select>
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-300">
           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" /></svg>
        </div>
      </div>
    ) : (
      <input type={type} value={value} onChange={e => onChange(e.target.value)} disabled={disabled} className={`w-full bg-slate-50 border-none rounded-2xl p-4 font-bold text-slate-800 focus:ring-2 focus:ring-indigo-500/20 outline-none ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`} />
    )}
  </div>
);

type PolicyToggleProps = {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
};

export const PolicyToggle: React.FC<PolicyToggleProps> = ({ label, checked, onChange }) => (
  <label className="flex items-center gap-3 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 ml-2 cursor-pointer">
    <input
      type="checkbox"
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      className="w-4 h-4 rounded border-2 border-slate-300 text-indigo-600 focus:ring-2 focus:ring-indigo-500"
    />
    {label}
  </label>
);
